export default {

  ICICI_BANK_LTD : 67,
  RBL_BANK : 250,
  SALES_DEMO_BFSI: 55,

 // Client business account id for Sales Demo
  SALES_DEMO_ECOM_BUSINESS_ACCOUNT_ID : 94,
  SALES_DEMO_BFSI_BUSINESS_ACCOUNT_ID : 95,

  FWD_ClIENT_SUPPORT  : 6 ,
  RVP_ClIENT_SUPPORT  : 7 ,
  ASSIGNED_CS_TEAM : 14,
  RTO_NOTIFIED :4,
  RTO :63,
  RTO_CANCEL: 77,                                     // RTO Cancellation Process   #rto_cancellation_7588
  HOLD_SUB_REASON  : 81 ,
// Declared constants of Arrange Delivery.
  FUTURE_DELIVERY : 24,
  URGENT_DELIVERY  : 25 ,
  SELF_COLLECT  : 26,
  CSAW_RTO_REATTEMPT : 88,
// Declared constants of Arrange pickup in Reverse Business flow.
  FUTURE_PICKUP  : 59 ,
  URGENT_PICKUP  : 60 ,
  PICKUP_WITHOUT_QC  : 61 ,
  EXCEPTIONAL_PICKUP  : 62 ,
  CSAW_DTO_REATTEMPT : 89,

//  Declared constants of Cancellation request in Forward business Flow.
  LATE_DELIVERY  : 28 ,
  PRICE_ISSUE  : 29 ,
  PRODUCT_ISSUE  : 30 ,
  DUPLICATE_ORDER  : 31 ,
  NEVER_ORDERED  : 32 ,
  ODA_LOCATION	 : 33 ,
  PURCHASED_FROM_OTHER_SITE  : 34 ,
  MIND_CHANGE  : 35 ,
  CUSTOMER_OUT_OF_STATION  : 75 ,
  CUSTOMER_WANT_OPEN_DELIVERY  : 76 ,
  DUE_TO_FAKE_UPDATE  : 79 ,
  COD_NOT_AVAILABLE : 87,
  SR_DEMAND_FOR_EXTRA_AMOUNT : 86,
  ORDERED_BY_MISTAKE : 85,
  NO_SUCH_REASON : 84,
  NOT_INTERESTED_TO_TAKE : 83,
  SR_MISBEHAVIOUR : 82,
  INCORRECT_PINCODE	: 91,
  CUSTOMER_SHIFTED	: 92,
  SOMEONE_ELSE_ORDERED : 93,
  FORGOT_TO_APPLY_PROMOCODE	: 94,
  REFUND_PENDING_OF_PREVIOUS_ORDER : 95,
  DEMISE_IN_FAMILY : 96,

// Contants of Cancellation request in Reverse Business Flow.
  QC_FAILED  : 63 ,
  AS_PER_CLIENT  : 64 ,
  PRODUCT_USED  : 65 ,
  PRODUCT_HANDEDOVER  : 66 ,
  OUT_SERVICE_AREA  : 67 ,
  DUPLICATE_REQUEST  : 68 ,
  RETURN_REASON_MISMATCH  : 69 ,

// Constants for reasons of forward.
  CANCELLATION_REQUEST  : 8 ,
  RTO_CANCELLATION_REQUEST:63,   // RTO Cancellation Process   #rto_cancellation_7588
  HOLD_REASON  : 16 ,
  ARRANGE_DELIVERY  : 7,

// Constants of reasons of reverse.
  ARRANGE_PICKUP  : 14,
  STATUS_CHANGED: 15,
  PAYMENT_DETAILS_CHANGE_REQUESTED : 45,

  INFORMATION_GIVEN:1,
  REFERRED_TO_CLIENT:2,
  CALL_DROPPED:9,

  ENQUIRY : 1,
  COMPLAINT: 2,
  REQUEST: 3,
  // Forward Escalations subreasons
  FAKE_NDR:133,
  REFUSED_DOORSTEP_DELIVERY : 136,

  //Reverse Escalations subreasons
  DELAY_IN_PICKUP_SUB_REASON : 131,
  FAKE_NPR : 119,
  FAKE_PICKUP : 120,
  DENIED_PICKUP : 121,

  //UNAUTORISED_USER_MSG
  UNAUTORISED_USER_MSG : 'You are not authorised user.',

  //Change pincode tagging.
  CHANGE_DELIVERY_PINCODE : 149,
  CHANGE_RTO_PINCODE : 150,
  CHANGE_DTO_PINCODE : 151,
  CHANGE_PICKUP_PINCODE : 152,

  //Change Address tagging
  
  CHANGE_RTO_ADDRESS : 47,
  CHANGE_DTO_ADDRESS : 48,
  ATTEMPT_DELIVERY : 58, //Attempt Delivery ACTION  

  //Wallet net mail
  Walletnetmail :23,

  FORWARD_COMPLAINT_BULK_LIMIT : 1000,
  REVERSE_COMPLAINT_BULK_LIMIT : 500,

  // change bulk limit 4000 to 10000
  // FORWARD_REQUEST_BULK_LIMIT  : 4000,
  FORWARD_REQUEST_BULK_LIMIT  : 10000,

  REVERSE_REQUEST_BULK_LIMIT  : 2000,
  FORWARD_REQUEST_B2C_HEAVY_BULK_LIMIT  : 100,
  FORWARD_REQUEST_B2C_HEAVY_AMOUNT_UPDATE : 1,
  FORWARD_REQUEST_B2BBULK_LIMIT:25,
  APPOINMENT_DATE_B2BBULK_LIMIT:500,  //#bulk_appointment B2B bulk limit change

  //Constant for Department Id 
  B2C_HEAVY_RTO : 236,
  CHANGE_COD_AMOUNT:214,
  POD:214,
  GOVT_ID_VERIFY:215,
  TEAM_LEADER:'Team Leader',              // #govt_proof_access
  
  //IVR NDR 
  NDR_Dialer_Team : 280,
  COD_Dialer_Team : 379,

  // #escalation_tag
  Escalation : 1,
  SuperEscalation : 2,

  //encryption secret key

  enckey : "secret",

  // token
  DEPARTMENT_ID_TOKEN : 'c423ed60f34c0021016fc65cb53a9ad4',
  
  // secretKey
  AES_SecretKey : 'Key',

  AI_ENABLED : true,

  //CSRF-TOKEN
  CSRF_TOKEN : '2fHsXOJG-mn2E2T-i3TaBU7Q4KXQKKdO4Wh8',

  SrSubReasonIdArr : [114, 115, 116, 117, 118],
  // === B2B CRM ALT Instruction Section Start === -- Added constants for all search tagging
  Alternate_Instruction_Pickup : 54,
  Alternate_Instruction_Delivery : 55,
  Amount_Updated: 69,                              // b2b_restrict_rto_client
  Escalation_For_Pickup: 252,
  Hold_Pickup: 253,
  Pickup_Details_Updates: 254,
  Reattempt_Time_Slot_Pickup: 256,
  Special_Instruction_Pickup: 257,
  Contact_Updated: 259,
  Escalation_For_Delivery: 261,
  Reattempt_Time_Slot_Delivery: 263,
  Attempt_Pickup: 373,
  Attempt_Delivery: 374,
  Address_Updated: 375,
  Updated_Contact: 376,
  Source_Consigner :12,
  Source_Consignee :11,  //#ebn_enhancement consignee
  Resolution_Information_Given : 1,
  // === B2B CRM ALT Instruction Section End ===
  Change_Appointment_Date: 74, //#bulk_appointment Appoinment date Action 
  IP_Tracking_Enabled: 'Y', //#ip_track ip tacking logs
  enckey_call_patching : '!xpress-bees', //#ip_track call patching key
   ndr_validation_departmentid : 412, //#7419
   ndr_validation: 60,//#7419
   verified_ndr :276, //#7419
  // ADI 7449 -- Added const for ticket creation -- start
  userType: "Inbound",
  userProcess_FWD: "Shipment got stolen or lost after OFD",
  userProcess_REV: "Customer not available",
  ticketTypeId: "3",
  ticketStatusId: "Closed",
  subReasonId_FWD: "46",
  subReason_FWD: "Change delivery address",
  subReason_REV: "Change Pickup address",
  subReasonId_REV: "49",
  sourceId: "1",
  routemode: "surface",
  reasonId: "9",
  pincodebusinessflow_fwd: "Forward",
  pincodebusinessflow_rev: "Reverse",
  location: "SR-GOA",
  escalation: 0,
  flag: "false",
  isLatestOfd: false,
  deptid: "6",
  emailAddress: "goa@xpressbees.com",
  businessservice: "Delivery",
  IsFakeNDRStatus: 0,
  SourceName: "Customer",
  action: "8",
  comments: "ADI_AdressCorrected_Customer",
  username: "lily.dsouza@xpressbees.com",
  userId: "38233",
  // ADI 7449 -- end
  Information_given_resolution: "Information given",
  VENDOR_DELAY_PICKUP: 277,
  VENDOR_FAKE_NPR: 278,
  NON_BEHAVIORAL:20,
 //track_security_7627 Search Reason Options
  SELECT_REASON_OPTIONS: [
    {
      value: 'CustomerTicket',
      text: 'Customer Ticket'
    },
    {
      value: 'CustomerEmail',
      text: 'Customer Email'
    },
    {
      value: 'ClientTrackingRequest',
      text: 'Client Tracking Request'
    },
    {
      value: 'ClientChangeRequest',
      text: 'Client Change Request'
    },
    {
      value: 'Others',
      text: 'Others'
    }
  ],
  
  NPR_Validation:64,
  Verified_NPR:288,
  RVP_NDR :"rvp_ndr",
  RVP_NDR_STATUS_CODE: "rp_ndr_status_code",
  // b2b_restrict_rto_client 
  // Client types for which RTO process needs to be restricted.
  B2B_RESTRICT_RTO_CLIENT_TYPES: ['fbp', 'prccredit', 'prcwallet', 'prepaid'],

  RTO_DTO_Validation:66,
  Verified_RTO_DTO_Reason:293,
  RTO_DTO_Verfication:480,
  OTP_REQUEST:37,
  GENERATE_OTP:292,
  SEND_OTP:378,
  rto_dto_verification: 480,      // subdepartmet id #rto_dto_verification    
};



// WEBPACK FOOTER //
// ./src/constantVariable.js